import jobCard from "../components/jobCard.vue";
import jobDetail from "../components/JobBoardDetail/jobDetail.vue";
import { mapGetters, mapActions } from "vuex";
import TextInput from "@/components/reusable/Fields/TextInput";
import router from "../router/index";
import {
  LOGIN_URL,
  getScope,
  Role,
  authUrlWithRedirect,
  jobViewPath,
  isEmptyObjectCheck,
  isObject,
} from "@/helpers/helper";
import GenericFilter from "@/components/reusable/GenericFilterAndSearch/index";
import advertisement from "@/components/reusable/Advertise.vue";
import Pagination from "@/components/reusable/Pagination";

export default {
  components: {
    "job-card": jobCard,
    "job-detail": jobDetail,
    TextInput,
    GenericFilter,
    advertisement,
    Pagination
  },
  data() {
    return {
      searchTerm: "",
      isMobile: false,
      successModal: false,
      modalMessage: "",
      page: "",
      currentUserRole: getScope(),
      Role,
      urlFullPath: "",
      jobId: "",
      jobAdvertisement: false,
      AddJobRoles: [
        Role.systemAdmin,
        Role.customerAdmin,
        Role.customerRecruiter,
        // Role.customerCandidate,
        Role.systemCandidate,
        Role.systemRecruiter,
      ],
      tempJobId: "",
      detail: null,
    };
  },
  async mounted() {
    this.$store.commit("IS_JOB_BOARD_LOADING", true)
    const { cus_id, org_id } = this.$route.params;
    let payload = {};

    if (cus_id) {
      payload = {
        customer_id: cus_id,
      };

      if (org_id) {
        payload.organisation_id = org_id;
      }
    }

      await this.fetchJobAdvertisement(payload);
      this.getCustomerAdvertisement(cus_id).then((data) => {
        const list = Array.isArray(data) ? data : [];
        const jobAd = list.find(v => v?.key === 'JOB_ADVERTISEMENT') ?? "";

        if (jobAd && ["ENTERPRISE", "TRUE"].includes(jobAd.value) && this.activeJobAdvertisement.length > 0) {
          this.jobAdvertisement = true;
        } else {
          this.jobAdvertisement = false;
        }
      });

    this.scrollTop();
    this.urlFullPath = this.$route.fullPath;
    let appendAction = [];
    if (!(isObject(this.getUser) && !isEmptyObjectCheck(this.getUser)))
      appendAction = [...appendAction, this.fetchUser()];
    Promise.all(appendAction).then((res) => {
      if (this.getIsParentUser)
        this.setCurrentPageSchema({ schema: "jobBoardSchemaForParentOrg" });
      if (this.isUKMainAgency) {
        // Set Pertemps Schema
        this.setCurrentPageSchema({ schema: "jobBoardPertempsSchema" });
      }
    });
    this.initAllFilters().then(async () => {
      // await this.clearAllSelectedFilters();
      let initialEmptySelectedCheck =
        await this.updateSelectedFilterFromFilterCode(
          this.$router.currentRoute.query
        );
      let queryUrl = this.getQueryResult.queryUrl;
      if (this.currentUserRole) {
        if (
          ["customer_candidate", "system_candidate"].includes(
            this.currentUserRole
          )
        ) {
          if (
            !(
              isObject(this.candidateProfile) &&
              !isEmptyObjectCheck(this.candidateProfile)
            )
          )
            await this.getUserMe({ customer: this.getCustomerId });
          await this.candidateJobCount({ query: "", isTotal: true });
        } else if (["system_admin"].includes(this.currentUserRole)) {
          await this.jobCount({ query: "", isTotal: true });
        } else if (
          ["customer_admin"].includes(this.currentUserRole) &&
          this.getRelationshipOrgDetail?.length
        ) {
          await this.agencyJobCount({ query: "", isTotal: true });
        } else {
          await this.facilityJobCount({ query: "", isTotal: true });
        }
      } else await this.jobCount({ query: "", isTotal: true });
      const pageNumber = parseInt(this.$router.currentRoute?.query?.page || 1);
      //Todo working on the two api calls issue
      this.jobBoardAction({
        page: this.page,
        query: this.getQueryResult.queryUrl,
        pageNumber,
      }).then(() => {
        let isMobile = window.matchMedia(
          "only screen and (max-width: 760px)"
        ).matches;
        this.isMobile = isMobile;
        let ele;
        if (!isMobile) {
          ele = document.getElementById("job-board-body");
        } else {
          if (this.urlFullPath.includes("/public")) {
            ele = document.getElementById("c-body-app");
          } else {
            ele = document.getElementById("c-body-app");
          }
        }
        if (ele && this.$route?.path != "/job-list") {
          ele.addEventListener("scroll", this.onBodyScroll);
        }
      });
    });
    this.$store.commit("RESET_JOB_LIST_BACK_URL");
  },
  beforeDestroy() {
    let ele;
    if (!this.isMobile) {
      ele = document.getElementById("job-board-body");
    } else {
      if (this.urlFullPath.includes("/public")) {
        ele = document.getElementById("app");
      } else {
        ele = document.getElementById("c-body-app");
      }
    }
    if (ele) {
      ele.removeEventListener("scroll", this.onBodyScroll);
    }
  },

  created() {
    if (this.getRoleScopes.length) {
      if (
        [
          "system_admin",
          "customer_candidate",
          "system_recruiter",
          "system_candidate",
        ].includes(this.getRoleScopes[0])
      ) {
        this.page = "publicJobBoard";
      } else {
        this.page = "jobBoard";
      }
    } else {
      this.page = "publicJobBoard";
    }
    this.setCurrentPageSchema({ schema: "jobBoardSchema" });
  },

  updated() {
    let { job_id } = this.$route.query;
    const jobId = parseInt(job_id) | 0;
    if (jobId !== this.jobId) {
      this.selectedJobBoard(parseInt(jobId));
    }
    this.jobId = jobId;
    let ele = document.getElementById("job-board-body");
    if (ele) {
      ele.addEventListener("scroll", this.onBodyScroll);
    }
  },
  methods: {
    ...mapActions([
      "scrollTop",
      "jobBoardAction",
      "selectedJobBoard",
      "applyJob",
      "showToast",
      "setCurrentPageSchema",
      "initAllFilters",
      "updateSelectedFilter",
      "clearSearchFilterWithUpdateSearch",
      "updateSelectedFilterFromFilterCode",
      "clearAllSelectedFilters",
      "jobCount",
      "facilityJobCount",
      "getUserMe",
      "candidateJobCount",
      "agencyJobCount",
      "fetchUser",
      "fetchAcronymByOrgDetail",
      "getGenericSpecialitySearchBasedOnId",
      "getGenericSpecialitySearchBasedOnCode",
      "getCustomerAdvertisement",
      "fetchJobAdvertisement",
    ]),
    searchCallback(payload) {
      payload["type"] = "searchTerm";
      this.updateRouterURL(payload);
    },
    jobCardSelectedCallback({ job_id }) {
      if (this.isMobile) {
        if (this.getRoleScopes.length) {
          if (
            this.getRoleScopes[0] === "system_admin" ||
            this.getRoleScopes[0] === "system_recruiter"
          ) {
            this.$router.push({ path: `/public/job-board-detail/${job_id}` });
          } else if (
            this.getRoleScopes[0] === "customer_admin" ||
            this.getRoleScopes[0] === "customer_recruiter"
          ) {
            this.$router.push({ path: `/job-board-detail/${job_id}` });
          } else if (
            ["customer_candidate", "system_candidate"].includes(
              this.getRoleScopes[0]
            )
          ) {
            this.$router.push({ path: `/public/job-board-detail/${job_id}` });
          } else {
            this.$router.push({ path: `/job-board-detail/${job_id}` });
          }
        } else if (this.isTFWPublicJobBoard) {
          this.$router.push({ path: `/tfm/job-board-detail/${job_id}` });
        } else {
          this.$router.push({ path: `/public/job-board-detail/${job_id}` });
        }
      } else {
        let path = `${this.$route.path}?job_id=${job_id}&${this.getQueryResult.routeUrl}`;
        this.$router
          .push({
            path,
          })
          .catch(() => {});
        this.selectedJobBoard(parseInt(this.$route.query.job_id));
      }
    },
    onBodyScroll(e) {
      if (this.noMoreDataFromJobBoard || this.isJobBoardFetching) return;
      // if (
      //   e.target.clientHeight + e.target.scrollTop >=
      //   e.target.scrollHeight - 1
      // ) {
      //   this.jobBoardAction({
      //     pagination: true,
      //     page: this.page,
      //     query: this.getQueryResult.queryUrl,
      //   });
      // }
    },
    handleSearchSubmit() {
      this.jobBoardAction(this.searchTerm);
    },
    handleSearchInput(name, value) {
      this.searchTerm = value;
    },
    clearSearch() {
      this.searchTerm = "";
      this.jobBoardAction();
    },
    // Logged-in apply/withdraw reuse jobDetail.vue's own flow via its ref; the modal here mirrors it.
    onApplyJob(jobId) {
      this.tempJobId = jobId;
      if (this.getRoleScopes.length) {
        this.detail.onApplyJob();
      } else {
        this.modalMessage = "Please login/Register to apply";
      }
      this.successModal = true;
    },
    onWithdrawJob() {
      this.detail.onWithdrawJob();
      this.successModal = true;
    },
    navigateToAddJob() {
      router.push("/add-job?step=0");
    },
    onShow(e, value) {
      if (this.getRoleScopes.length) {
        this.detail.onShow(e, value);
        return;
      }
      if (value.target.textContent === " OK ") {
        // After login/sign-up the candidate lands on this job's page.
        this.$router.push(authUrlWithRedirect(jobViewPath(this.tempJobId))).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.error(err);
          }
        });
      }
    },
    updateRouterURL(payload) {
      let appendAction = [];
      if (payload?.name === "specialitySearch")
        appendAction = [
          ...appendAction,
          this.getGenericSpecialitySearchBasedOnCode(payload),
        ];
      else appendAction = [...appendAction, this.updateSelectedFilter(payload)];
      Promise.all(appendAction).then((res) => {
        let path = `${this.$route.path}?${this.getQueryResult.routeUrl}`;
        this.$router.push({ path });
      });
    },
    filterAction(isAsync = false) {
      if (isAsync) {
        const appendAction = this.getGenericSpecialitySearchBasedOnId();
        Promise.all([appendAction]).then(async (res) => {
          await this.updateSelectedFilterFromFilterCode(
            this.$router.currentRoute.query
          );
          this.jobBoardAction({
            page: this.page,
            query: this.getQueryResult.queryUrl,
          });
        });
      } else {
        this.initAllFilters().then(async () => {
          await this.clearAllSelectedFilters();
          await this.updateSelectedFilterFromFilterCode(
            this.$router.currentRoute.query
          );
          this.jobBoardAction({
            page: this.page,
            query: this.getQueryResult.queryUrl,
          });
        });
      }
    },
    async pagechanged(value) {
      const page = Number(value) > 0 ? Number(value) : 1;

      this.$router.push({
        path: this.$route.path,
        query: { ...this.$route.query, page: String(page) },
      })

      await this.jobBoardAction({
          pagination: true,
          page: this.page,
          query: this.getQueryResult.queryUrl,
          skip: (value - 1) * 10,
        });
    },
  },
  computed: {
    displayMessage() {
      return this.getRoleScopes.length
        ? this.detail?.modalMessage
        : this.modalMessage;
    },
    customMarginBasedOnPage() {
      if (
        this.getRoleScopes.length &&
        this.$route.path !== "/public/job-board"
      ) {
        return 10;
      }
      return 70;
    },
    backURL() {
      return this.isTFWPublicJobBoard ? `/tfm` : "";
    },
    ...mapGetters([
      "getJobBoard",
      "getSelectedJobBoard",
      "noMoreDataFromJobBoard",
      "isJobBoardFetching",
      "getJobCount",
      "getFilterCount",
      "getRoleScopes",
      "jobBoardSchema",
      "jobBoardSchemaForCandidate",
      "jobBoardSchemaForParentOrg",
      "jobBoardPertempsSchema",
      "selectedFilters",
      "filterDependencyObj",
      "isFetchingGenericFilter",
      "getQueryResult",
      "isSelectedFilterUpdated",
      "getCustomerId",
      "candidateProfile",
      "getRelationshipOrgDetail",
      "getIsParentUser",
      "getUser",
      "setNewOrgAcronym",
      "getSelectedCustomerVariant",
      "isUKMainAgency",
      "isJobSupplierFromAccessToken",
      "getJobBoardPaginationLimit",
      "isSuperCustomer",
      "jobAdvertisements",
      "isLoading"
    ]),
    getFilterSchema() {
      this.variant = this.getSelectedCustomerVariant;

      return this.currentUserRole
        ? { schema: this.jobBoardSchema, basicFilterLength: 4 }
        : { schema: this.jobBoardSchemaForCandidate, basicFilterLength: 5 };
    },
    isTFWPublicJobBoard() {
      const { name } = this.$route;
      return ["TFW Job Board"].includes(name) || false;
    },
    isTFW() {
      return this.$route?.path.includes("/tfm") || false;
    },
    activeJobAdvertisement() {
      return this.jobAdvertisements.filter(({ is_active }) => is_active) || [];
    },
    // isLoading() {

    //   // return (
    //   //   this.isFetchingGenericFilter ||
    //   //   this.isJobBoardFetching
    //   // );
    // },
  },
  watch: {
    isFetchingGenericFilter() {
      this.$store.dispatch("triggerLoader", this.isFetchingGenericFilter || this.isJobBoardFetching);
    },
    isJobBoardFetching() {
      this.$store.dispatch("triggerLoader", this.isFetchingGenericFilter || this.isJobBoardFetching);
    },
  },
};
